import React from 'react';
import Const from 'const.json';
import BasePeriodSelector from './BasePeriodSelector/BasePeriodSelector';
import { MonthData, SelectionProps } from 'types/PeriodSelectionTypes'
import * as utilsLogic from 'utils/utilsLogic'
import { MonthEnum, SelectionTypeEnum } from 'enums/enums';
import Icon from 'components/ui/Icon';
import CalendarIcon from 'assets/icons/calendar.svg';

const months: MonthData[] = [
  { months: MonthEnum.January, description: 'ינואר' },
  { months: MonthEnum.February, description: 'פברואר' },
  { months: MonthEnum.March, description: 'מרץ' },
  { months: MonthEnum.April, description: 'אפריל' },
  { months: MonthEnum.May, description: 'מאי' },
  { months: MonthEnum.June, description: 'יוני' },
  { months: MonthEnum.July, description: 'יולי' },
  { months: MonthEnum.August, description: 'אוגוסט' },
  { months: MonthEnum.September, description: 'ספטמבר' },
  { months: MonthEnum.October, description: 'אוקטובר' },
  { months: MonthEnum.November, description: 'נובמבר' },
  { months: MonthEnum.December, description: 'דצמבר' }
];

const MonthSelection: React.FC<SelectionProps> = (SelectionProps) => {

  const renderButtonContent = (month: MonthData) => (
    <div className='monthlyPeriod'>
      <Icon src={CalendarIcon} alt='' />
      <p className='m-0 mt-2 text-nowrap fs-7'>{month.description}</p>
    </div>
  );

  const handleSelectionChange = utilsLogic.SelectionChangeHandler(SelectionTypeEnum.Monthly, SelectionProps);

  return (
    <BasePeriodSelector
      selectionMode='multiple'
      periods={months}
      renderButtonContent={renderButtonContent}
      selectionLabel={Const.monthSelection}
      maxSelection={Const.MONTH_MAX_SELECTIONS}
      onSelectionChange={handleSelectionChange}
      indexes={SelectionProps.indexes}
    />
  );
};

export default MonthSelection;
